document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a[href]').forEach((linkEl) => {
    if (linkEl.hostname !== location.hostname) {
      linkEl.target = '_blank';
    }
  });

// Media protection: disabled 2026-10-06 at client request (Teamwork #26440901).
// Kept for future use. To re-enable, remove the /* */ wrapper below and the
// one around the matching rules at the end of assets/custom.css.
/*
  // Prevent right-click context menu on all media elements
  document.addEventListener('contextmenu', (e) => {
    const el = e.target;
    if (
      el.matches('img, video, svg, picture, canvas, model-viewer') ||
      el.closest('picture, video, svg, model-viewer')
    ) {
      e.preventDefault();
    }
  });

  // Prevent drag-and-drop saving of images
  document.addEventListener('dragstart', (e) => {
    const el = e.target;
    if (
      el.matches('img, video, svg, picture, canvas') ||
      el.closest('picture, video, svg')
    ) {
      e.preventDefault();
    }
  });
*/

});



